/** Public store listing URLs for the native mobile apps. */
export const APP_STORE_URL = 'https://apps.apple.com/gr/app/breath-lab/id6743932780';
export const PLAY_STORE_URL =
  'https://play.google.com/store/apps/details?id=com.sequence.studios.breathLab';

/** Official social profiles. */
export const INSTAGRAM_URL = 'https://www.instagram.com/breath__lab';

/** App Store numeric id, used by the iOS Smart App Banner meta tag. */
export const APP_STORE_APP_ID = '6743932780';
/** Custom URL scheme registered by the mobile app (apps/mobile/app.json). */
export const APP_URL_SCHEME = 'breathlab';
/** Android application id / package name. */
export const ANDROID_PACKAGE = 'com.sequence.studios.breathLab';

/**
 * Android intent: URL that opens the installed app via its scheme + package,
 * falling back to the Play Store listing when the app is not installed.
 * See https://developer.chrome.com/docs/android/intents.
 */
export function buildAndroidIntentUrl(): string {
  const fallback = encodeURIComponent(PLAY_STORE_URL);
  return `intent://#Intent;scheme=${APP_URL_SCHEME};package=${ANDROID_PACKAGE};S.browser_fallback_url=${fallback};end`;
}
